import { Droplets, FileText, Calculator, ShieldCheck, Clipboard, CalendarDays, Palette, Truck, Sparkles } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const PowerWashingIndustry = () => (
  <IndustryPlaceholderPage
    name="Power Washing"
    fullySupported={false}
    icon={Droplets}
    iconColor="text-info"
    iconBg="bg-[hsl(var(--info)/0.1)]"
    headline="Power Washing Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps power washing companies build technical, surface-specific proposals — soft-wash to flatwork to fleet — with EPA-compliant scope and instant pricing."
    valueProps={[
      { title: "Win More Bids", description: "Generate detailed power washing proposals with surface-by-surface methods, PSI selection, chemistry, and pricing — faster than your competition." },
      { title: "Stay EPA-Compliant", description: "Built-in water-reclamation pricing and scope language for stormwater compliance on commercial and fleet jobs." },
      { title: "Built for Power Washers", description: "Industry-specific templates for residential soft-wash, commercial flatwork, fleet, and specialty remediation — designed by professionals." },
    ]}
    features={[
      { icon: Calculator, label: "Surface Cost Calculators" },
      { icon: Droplets, label: "Soft-Wash vs Pressure Logic" },
      { icon: Truck, label: "Fleet Wash Templates" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: ShieldCheck, label: "EPA / Stormwater Scope" },
      { icon: Sparkles, label: "Specialty Remediation" },
      { icon: CalendarDays, label: "Recurring Service Plans" },
      { icon: Palette, label: "Custom Branding" },
    ]}
    benefits={[
      "Build proposals with surface-specific PSI, nozzle, and chemistry recommendations",
      "Auto-calculate pricing by square footage with overhead and profit margins",
      "Add water reclamation costs automatically for EPA-compliant commercial jobs",
      "Send branded contracts with digital signatures for fast approval",
      "Manage one-time, recurring, and per-unit fleet wash agreements",
      "Includes templates for residential, commercial flatwork, fleet, and specialty work",
    ]}
    proposalTemplates={[
      "Residential Exterior Soft Wash",
      "Driveway & Concrete Cleaning",
      "Commercial Storefront & Sidewalk",
      "Fleet & Heavy Equipment Wash",
      "Graffiti & Stain Remediation",
    ]}
    contractTemplates={[
      "Residential Power Washing Agreement",
      "Commercial Flatwork & Storefront Contract",
      "Fleet & Heavy Equipment Wash Agreement",
      "Specialty Remediation Contract",
    ]}
    faq={[
      { q: "What is Sentinel Forge for power washing companies?", a: "It's a proposal and contract platform built for pressure washing pros. Generate technical, surface-specific proposals with PSI, chemistry, and EPA-compliant scope in minutes." },
      { q: "Does it handle soft-wash vs high-pressure differences?", a: "Yes. The AI selects the right method (soft-wash, standard, or high-pressure) based on the substrate — siding, EIFS, roofs, and wood get appropriate low-pressure chemistry." },
      { q: "What about water reclamation for commercial jobs?", a: "Toggle 'water reclamation required' and the calculator adds an EPA compliance fee, while the proposal scope automatically references NPDES stormwater compliance and BMP language." },
      { q: "Can I create fleet wash contracts?", a: "Yes. The Fleet & Heavy Equipment template supports per-unit pricing, two-step truck wash, aluminum brightener, and DOT inspection prep." },
      { q: "Does it support specialty work like graffiti or rust?", a: "Yes — the Specialty Remediation template covers graffiti removal, oil-stain remediation, rust removal, and efflorescence with substrate testing protocols." },
      { q: "Can clients sign digitally?", a: "Yes. Clients receive a secure link to review and digitally sign — no account or printer required." },
      { q: "When will power washing be available?", a: "We're building it now. Join the waitlist to be notified when the power washing module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support system." },
    ]}
    ctaHeadline="Ready to modernize your power washing business?"
    ctaDescription="Join power washing companies preparing to automate proposals and contracts with Sentinel Forge."
  />
);

export default PowerWashingIndustry;
